import styled from "@emotion/styled";
import { defaultFocusStyle, setHoverStyle } from "theme/styles/mixins";
import BaseInput from "../../BaseInput";

const BaseDropzone = styled.div`
  --Dropzone-aspect-ratio: 350 / 220;

  display: flex;
  align-items: center;
  justify-content: center;
  inline-size: 100%;
  aspect-ratio: var(--Dropzone-aspect-ratio);
  overflow: hidden;

  a,
  .fake-link {
    ${setHoverStyle()}

    &:focus-visible {
      outline: 0;
    }
  }
`;

export const Dropzone = styled(BaseDropzone)`
  --FieldGroup-child-flex-basis: 100%;

  position: relative;
  cursor: pointer;
  max-width: var(--Dropzone-max-width, 350px);
  border: 1px solid var(--input-border-color);
  border-radius: var(--box-border-radius);
  transition: border-color 0.2s, background-color 0.2s;

  .reader & {
    background-color: var(--box-medium-bg-color);
    border-color: transparent;

    &:hover {
      border-color: var(--strong-color);
      background-color: var(--box-weak-bg-color);
    }
  }
`;

export const Fieldset = styled.fieldset`
  > legend + ${Dropzone} {
    margin-block-start: 0.75em;
  }
`;

export const AvatarBuilderDropzone = styled(BaseDropzone)`
  --Dropzone-aspect-ratio: 275 / 200;

  position: relative;
  width: 100%;
  max-block-size: 200px;
`;

export const Prompt = styled.span`
  cursor: pointer;
  text-decoration-line: underline;
  transition: color var(--transition-duration-default)
    var(--transition-timing-function);

  &:hover {
    color: var(--hover-color);
  }

  .reader & {
    color: var(--reader-color);

    &:hover {
      color: var(--reader-color);
    }
  }
`;

export const Input = styled.input`
  &:focus-visible {
    outline: 0;

    + * ${Prompt} {
      ${defaultFocusStyle}
      outline-color: var(--focus-color);
    }
  }
`;

export const AltTextInput = styled(BaseInput)`
  margin-block-start: 20px;
`;
